export default function once(fn) {
  let didRun = false;
  let result;
  return function (...args) {
    if (!didRun) {
      didRun = true;
      result = fn.apply(this, args);
    }
    return result;
  };
}